<template>
  <div class="news-home-main-banner-wrap">
      <div class="news-home-main-banner">
          <ul>
              <li v-for="(item,index) in carouselList" :key="index" v-show="listIndex===index" @mouseover="changeMouse(true)" @mouseleave="changeMouse(false)">
                  <!-- <a href="">
                      <img :src="item.url" alt="">
                  </a> -->
                  <router-link :to="{path:'/detail', query:{id:item.id}}" target="_blank">
                    <img :src="item.url"  :width="widthImage+'%'" :height="heightImage+'%'"/>
                  </router-link>
              </li>
          </ul>
          <ol @click="changePage(prev)">
              <li>
                  <span style="left: 8px;"></span>
              </li>       
          </ol>
          <ol @click="changePage(next)">
               <li>
                  <span></span>
              </li>
          </ol>
          <ul style="bottom: 0;left: 50%;-webkit-transform: translateX(-50%);transform: translateX(-50%);position: absolute;list-style: none;margin: 0;padding: 0;z-index: 2;">
              <li v-for="(item,index) in carouselList" :key="index" @click="changeBtn(index)" :class="listIndex===index? 'active':''">
                  <span></span>
              </li>
          </ul>
      </div>
  </div>
</template>

<script>
export default {
  //接收来自父组件的数据
  props: {
    // 轮播图宽度
    width: {
      type: Number,
      default:0
    },
    height: {
      type: String,
      default: '320'
    },
    // 相邻两张图片切换的间隔时间
    interval: {
      type: Number,
      default: 3000
    },
      //图片宽
    widthImage:{
      type: Number,
      default: 100
    },
    //图片高
    heightImage:{
      type: Number,
      default: 100
    },
    // 轮播图路径数组
    carouselList: {
      type: Array,
      default: function(){
        return [];
      }
    }
  },
 data() {
    return {
      // BannerList:[
      //           {id:250,url:require('@/assets/image/productBanner/man/banner/beidouxing.jpg'),title:"日本全自动飞机杯男用品成人情趣电动加热伸缩口交器男性自慰神器"},
      //           {id:250,url:require('@/assets/image/productBanner/man/banner/duyao.jpg'),title:'日本全自动飞机杯男用品成人情趣电动加热伸缩口交器男性自慰神器'},
      //           {id:252,url:require('@/assets/image/productBanner/man/banner/fuchouzhe.jpg'),title:"日本全自动飞机杯男用品自慰神器进口情趣电动伸缩旋转夹吸口交器"},
      //           {id:244,url:require('@/assets/image/productBanner/man/banner/maichong.jpg'),title:"飞机杯男用品阴茎训练器降低龟头敏感度锻炼拉伸按摩私处jj打神器"},
      //           {id:246,url:require('@/assets/image/productBanner/man/banner/pigu.jpg'),title:"飞机男杯下半身实体真人倒模熟女大硅胶屁股男性专用成人用品玩具"}
      // ],
      listIndex:0,
      timer:null,
    }
 },
 created(){
      this.setTimer();
 },
 computed:{
      prev(){
          if(this.listIndex==0){
              return this.carouselList.length-1;
          }else{
              return this.listIndex-1
          }
      },
      next(){
          if(this.listIndex==this.carouselList.length-1){
              return 0
          }else{
              return this.listIndex+1
          }
      }
 },
 methods:{
      changePage(index){
          this.listIndex=index
      },
      out(){
          this.setTimer()
      },
      over(){
          clearInterval(this.timer)
      },
      setTimer(){
          clearInterval(this.timer);
          this.timer=setInterval(()=>{
              this.listIndex++;
              if(this.listIndex==this.carouselList.length){
                  this.listIndex=0
              }
          },2000)
      },
      changeBtn(index){
this.listIndex=index
      },
      changeMouse(mouser){
          if(mouser){
              clearInterval(this.timer)
          }else{
              this.setTimer()
          }
      }
 },
 mounted(){
  this.setTimer()
 }
}
</script>

<style lang="css" scoped>
.news-home-main-banner-wrap{
  height: 320px;
  width: 890px;
  /* border-radius: 10px; */
  overflow: hidden;
}
.news-home-main-banner{
  position: relative;
  width: 890px;
  height: 320px;
}
.news-home-main-banner ul:nth-child(1) {
  display: flex;
  justify-content: flex-start;
}
.news-home-main-banner ul:nth-child(1) li a img{
  height: 320px;
  width: 890px;
}
.news-home-main-banner ol{
  /* position: absolute; */
  /* top: 50%; */
  border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    height: 62px;
    width: 28px;
    cursor: pointer;
    -webkit-transition: .3s;
    transition: .3s;
    background-color: #000;
    color: #FFF;
    position: absolute;
    top: 50%;
    z-index: 10;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    text-align: center;
    font-size: 12px;
    opacity: 0.6;
}
.news-home-main-banner ol:nth-child(2){
  left: 0px;
}
.news-home-main-banner ol:nth-child(3){
  right: 0px;
}
.news-home-main-banner ol li span{
  display: block;
  height: 15px;
  width: 15px;
  border-top: 4px solid #ffffff;
  border-right: 4px solid #ffffff;
  opacity: 0.8;
  /* text-align: center; */
  /* left: 8px; */
  position: relative;
  top: 22px;
  /* vertical-align: middle; */
}
.news-home-main-banner ol:nth-child(2) li span{
  transform: rotate(-135deg);
  /* // border-radius: 12px 0 12px 12px; */
}
.news-home-main-banner ol:nth-child(3) li span{
  transform: rotate(45deg);
   /* border-radius: 12px 0 12px 12px; */
}
.news-home-main-banner ul:nth-child(4) {
  position: absolute;
  right: 10px;
  bottom: 5px;
  display: flex;
  justify-content: center;
}
.news-home-main-banner ul:nth-child(4) li{
  height: 2px;
  width: 30px;
  /* border-radius: 12px; */
  margin: 0 5px;
  opacity: 0.8;
  cursor: pointer;
  margin-bottom: 5px;
}
.news-home-main-banner ul:nth-child(4) li span{
  display: block;
  height: 2px;
  width: 30px;
  /* margin: 2px; */
  /* border-radius: 11px; */
  text-align: center;
  /* line-height: 22px; */
  background: #ffffff;
  opacity: 0.8;
  color: #ffffff;
  font-weight: bold;
}
.active{
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/common/catesearch-carousel.vue